import {
  Award,
  CalendarDays,
  CircuitBoard,
  Codesandbox,
  FileText,
  Handshake,
  Contact,
  LifeBuoy,
  LocateFixed,
  Mail,
  Map,
  MessageSquare,
  MonitorDot,
  PackagePlus,
  PictureInPicture2,
  PieChart,
  RadioTower,
  ScrollText,
  Share2,
  ShoppingBag,
  Table,
  Building,
  Trophy,
  UserCog,
  UserCog2,
  UserRound,
} from "lucide-react";
import {
  ADMIN_ADMIN_LIST_ROUTE,
  ANNOUNCEMENT_LIST_ROUTE,
  CONTENT_LIST_ROUTE,
  BLOG_AUTHOR_LIST_ROUTE,
  PODCAST_LIST_ROUTE,
  BLOG_LIST_ROUTE,
  ICON_LIST_ROUTE,
  JOB_LIST_ROUTE,
  MEDIA_LIST_ROUTE,
  MODULE_LIST_ROUTE,
  PAGE_LIST_ROUTE,
  PAGE_VIEW_LIST_ROUTE,
  PEOPLE_LIST_ROUTE,
  CONTACT_US_LIST_ROUTE,
  CUSTOMER_LIST_ROUTE,
  PERMISSION_LIST_ROUTE,
  PRESS_RELEASE_LIST_ROUTE,
  ROLE_LIST_ROUTE,
  ROLES_EDIT_LIST_ROUTE,
  NEWS_LIST_ROUTE,
  EDITABLE_LIST_ROUTE,
  USER_PROFILE_LIST_ROUTE,
  HEADER_LIST_ROUTE,
  INDEX_LIST_ROUTE,
  DASHBOARD_LIST_ROUTE,
  INDEX_UPLOAD_LIST_ROUTE,
  JOB_APPLICATION_LIST_ROUTE,
  NOTICE_LIST_ROUTE,
  ADDITIONAL_HTML_LIST_ROUTE,
  HR_PAGE_LIST_ROUTE,
  COMPLIANCE_PAGE_LIST_ROUTE,
  OPERATIONS_PAGE_LIST_ROUTE,
  MARKETING_PAGE_LIST_ROUTE,
  BLOG_CATEGORY_LIST_ROUTE,
  AUDIT_LOG_LIST_ROUTE,
  CATEGORY_LIST_ROUTE,
  SUB_CATEGORY_LIST_ROUTE,
  WORKER_JOBS_LIST_ROUTE,
} from "../constants/routeEnum";

const menuData: any = [
  {
    label: "menu",
    isTitle: true,
  },
  {
    id: "dashboard",
    label: "Dashboard",
    link: DASHBOARD_LIST_ROUTE,
    icon: <LocateFixed />,
    permission: "dashboard:read",
  },
  {
    id: "admins",
    label: "Admins",
    link: "/admin",
    icon: <UserCog2 />,
    permission: "admin:read",
    subItems: [
      {
        id: "admin-list",
        label: "Admin List",
        link: ADMIN_ADMIN_LIST_ROUTE,
        parentId: "admins",
        permission: "admin:read",
      },
      {
        id: "modules",
        label: "Modules",
        link: MODULE_LIST_ROUTE,
        parentId: "admins",
        permission: "module:read",
      },
      {
        id: "permission",
        label: "Permissions",
        link: PERMISSION_LIST_ROUTE,
        parentId: "admins",
        permission: "permission:read",
      },
      {
        id: "roles",
        label: "Roles",
        link: ROLE_LIST_ROUTE,
        parentId: "admins",
        permission: "role:read",
      },
      {
        id: "auditlog",
        label: "Activity Logs",
        link: AUDIT_LOG_LIST_ROUTE,
        parentId: "admins",
        permission: "auditlog:read",
      },
    ],
  },

  {
    id: "media",
    label: "Media",
    link: MEDIA_LIST_ROUTE,
    icon: <UserRound />,
    permission: "media:read",
  },
  {
    id: "icon",
    label: "Icon",
    link: ICON_LIST_ROUTE,
    icon: <MonitorDot />,
    permission: "icon:read",
  },
  {
    id: "blog",
    label: "Blog",
    link: BLOG_LIST_ROUTE,
    icon: <FileText />,
    permission: "blog:read",
  },
  {
    id: "blogCategory",
    label: "BlogCategory",
    link: BLOG_CATEGORY_LIST_ROUTE,
    icon: <MessageSquare />,
    permission: "blogcategory:read",
  },

  {
    id: "blogAuthor",
    label: "BlogAuthor",
    link: BLOG_AUTHOR_LIST_ROUTE,
    icon: <MessageSquare />,
    permission: "blogauthor:read",
  },

  {
    id: "Pages",
    label: "Pages",
    link: PAGE_LIST_ROUTE,
    icon: <PackagePlus />,
    permission: "page:read",
  },
  {
    id: "HR Pages",
    label: "HR Pages",
    link: HR_PAGE_LIST_ROUTE,
    icon: <PackagePlus />,
    permission: "hr:read",
  },
  {
    id: "Compliance Pages",
    label: "Compliance Pages",
    link: COMPLIANCE_PAGE_LIST_ROUTE,
    icon: <PackagePlus />,
    permission: "compliance:read",
  },
  {
    id: "Operations Pages",
    label: "Operations Pages",
    link: OPERATIONS_PAGE_LIST_ROUTE,
    icon: <PackagePlus />,
    permission: "operations:read",
  },
  {
    id: "Marketing Pages",
    label: "Marketing Pages",
    link: MARKETING_PAGE_LIST_ROUTE,
    icon: <PackagePlus />,
    permission: "marketing:read",
  },
  {
    id: "announcement",
    label: "Announcement",
    link: ANNOUNCEMENT_LIST_ROUTE,
    icon: <Mail />,
    permission: "announcement:read",
  },
  {
    id: "pressrelease",
    label: "PressRelease",
    link: PRESS_RELEASE_LIST_ROUTE,
    icon: <CalendarDays />,
    permission: "pressrelease:read",
  },
  {
    id: "contactus",
    label: "ContactUs",
    link: CONTACT_US_LIST_ROUTE,
    icon: <Handshake />,
    permission: "contactus:read",
  },
  {
    id: "customer",
    label: "Customer Signup",
    link: CUSTOMER_LIST_ROUTE,
    icon: <Contact   />,
    permission: "contactus:read",
  },
  {
    id: "index",
    label: "Index Page",
    link: INDEX_LIST_ROUTE,
    icon: <MessageSquare />,
    permission: "index:read",
  },
  {
    id: "index-upload",
    label: "Index Upload",
    link: INDEX_UPLOAD_LIST_ROUTE,
    icon: <MessageSquare />,
    permission: "indexupload:read",
  },
  {
    id: "worker-jobs",
    label: "Worker Jobs",
    link:  WORKER_JOBS_LIST_ROUTE,
    icon: <MessageSquare />,
    permission: "admin:read",
  },
  {
    id: "content",
    label: "Contents",
    link: "/content",
    icon: <Building />,
    permission: "content:read",
    subItems: [
      {
        id: "podcast",
        label: "Podcast",
        link: PODCAST_LIST_ROUTE,
        parentId: "content",
        permission: "podcast:read",
      },
      {
        id: "content-list",
        label: "Content List",
        link: CONTENT_LIST_ROUTE,
        parentId: "content",
        permission: "admin:read",
        subItems: [
          {
          id: "content-list",
          label: "Content List",
          link: CONTENT_LIST_ROUTE,
          parentId: "content-list",
          permission: "admin:read",
          },
          {
            id: "category-list",
            label: "Category List",
            link: CATEGORY_LIST_ROUTE,
            parentId: "content-list",
            permission: "admin:read",
          },
          {
            id: "sub-category-list",
            label: "Sub-Category List",
            link: SUB_CATEGORY_LIST_ROUTE,
            parentId: "content-list",
            permission: "admin:read",
          },
        ]
      },
      
      {
        id: "editable-list",
        label: "Editable List",
        link: EDITABLE_LIST_ROUTE,
        parentId: "content",
        permission: "editable:read",
      },
      {
        id: "header-list",
        label: "Dynamic Header Footer",
        link: HEADER_LIST_ROUTE,
        parentId: "content",
        permission: "admin:read",
      },
      {
        id: "news",
        label: "News",
        link: NEWS_LIST_ROUTE,
        parentId: "content",
        permission: "news:read",
      },
      {
        id: "jobs",
        label: "Jobs",
        link: JOB_LIST_ROUTE,
        parentId: "content",
        permission: "job:read",
      },
      {
        id: "jobapplication",
        label: "Job Application",
        link: JOB_APPLICATION_LIST_ROUTE,
        parentId: "content",
        permission: "jobapplication:read",
      },
      {
        id: "additional-html",
        label: "AdditionalHtml",
        link: ADDITIONAL_HTML_LIST_ROUTE,
        parentId: "content",
        permission: "additionalhtml:read",
      },
      {
        id: "people",
        label: "People",
        link: PEOPLE_LIST_ROUTE,
        parentId: "content",
        permission: "people:read",
      },
      // {
      //   id: "notice",
      //   label: "Notice",
      //   link: NOTICE_LIST_ROUTE,
      //   parentId: "content",
      //   permission: "notice:read",
      // },
    ],
  },
];

export { menuData };
